module.exports = {
      id: "icons:tick-usage",
      viewBox: "0 0 11 8",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#icons:tick-usage",
      toString: function () {
        return this.url;
      }
    }